import { Component, OnInit, NO_ERRORS_SCHEMA } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from '../../../component/shared/shared.service';
import { Patient, Search } from '../model/patient';
import { PatientService } from '../service/patient-service.service';
import { MedicalHistory } from '../../master/model/medical-history';
import { MedicalHistoryService } from '../../master/services/medical-history.service';
import { DialogAction, ActionMessage } from '../../../shared/enum/dialog-action.enum';
import { Appointment } from '../../appointment/model/appointment';
import { UserService } from '../../user/service/user.service';
import { AuthServiceService } from '../../../component/service/auth-service.service';
@Component({
  selector: 'app-view-patient-profile',
  templateUrl: './view-patient-profile.component.html',
  styleUrls: ['./view-patient-profile.component.css']
})
export class ViewPatientProfileComponent implements OnInit {
  
  authService : AuthServiceService;
  usrData : Patient ;
  loading : boolean = false;
  listLoading : boolean = false;
  message : string = "";
  Patients : Patient[];
  selectedObject : Patient;
  isAdd : boolean = true;
  searchAlphabets : string[];
  search : Search = new Search('');
  id: number;
  appId: number= 0;
  dob: any ={};
  appdata : number = null;
  PatientsList : Patient[];
  filterText : string;
  isEditProfile : boolean;
  selectedObj : any = Patient;
  appointmentList : Appointment[] = [] ;
  medicalHistoryData : MedicalHistory[];
  user:any;
  isAddAppointment: boolean = false;
  isAppointment: boolean = false;
  isVitalTab: boolean = false;
  isClinicalNote: boolean = false;
  isPrescription: boolean = false;
  isSuperAdmin:boolean = false;

  private sub: any;
  constructor(authorizationService : AuthServiceService,private _sharedService: SharedService, private _usrService : PatientService, private route: ActivatedRoute, private _mhService : MedicalHistoryService, private _userService : UserService) { 
    this.authService = authorizationService; 
    this.filterText = 'All'; 
     this.isEditProfile = false;
     this.searchAlphabets = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z']
     _sharedService.yesEmitted$.subscribe(
      text => {
          if(text.Action===DialogAction.DELETE.toString() && text.Page === 'PATIENTPROFILE') {
              this.delete(text.Data);
          }  
      });
      if(this.authService.getUserRole() === "1") {
        this.isSuperAdmin = true;
      }
  }
  color:string = 'doc-list hoverList';
  defaultStyle:string = 'doc-list outList';
  hoveredDivId :number;
  changeStyle($event, id, index){
     $event.type == 'mouseover' ? this.hoveredDivId = id : this.hoveredDivId = null;      
  }
  deepCopy(oldObj: any) {
    var newObj = oldObj;
    if (oldObj && typeof oldObj === "object") {
        newObj = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
        for (var i in oldObj) {
            newObj[i] = this.deepCopy(oldObj[i]);
        }
    }
    return newObj;
}
getUserDetail(id : number) : void {
  this.loading = true;
  this._usrService.getPatientDetail(id).subscribe(data=>{
    this.Patients.push(data[0]);
    this.loading = false;
    this.usrData = data[0];
    if(this.usrData.PatientDOB !== null && this.usrData.PatientDOB !== "") {
      let db = this.usrData.PatientDOB.split('-');
      this.usrData.PatientDOB = db[2] + '-' +  db[1] + '-'+db[0];
    }
    this.selectedObj = data[0];
    this.hoveredDivId = this.usrData.PatientId;
    this.GetPatientAppointment();
  },
  error=>{
      this.loading = false;
      this.message = error.data;
  });
}
  setActiveTab(tab: string) {
      this.isAddAppointment = false;
      this.isAppointment = false;
      this.isVitalTab = false;
      this.isClinicalNote = false;
      this.isPrescription = false;
      if(tab==='APPOINTMENT') {
        this.isAppointment = true;
      } else if(tab==='ADDAPPOINTMENT') {
        this.isAddAppointment = true;
      } else if(tab==='VITAL') {
        this.isVitalTab = true;
      } else if(tab==='CLINICAL') {
        this.isClinicalNote = true;
      } else {
        this.isPrescription = true;  
      }
  }

  getUsers(id : number) : void {
      this.loading = true;
      var txtSearch = this.search.text;
      var fText = this.filterText;
      this._usrService.getPatientForSearch(fText, txtSearch).subscribe(data=>{
        this.loading = false;
        this.Patients  = data;
        
        if(id != undefined && id != null){
          var data = this.Patients.filter(function(user){
            return (user.PatientId === id);
          })
          if(data.length>0){
            this.usrData = this.deepCopy(data[0]);
            if(this.usrData.PatientDOB !== null && this.usrData.PatientDOB !== "") {
              let db = this.usrData.PatientDOB.split('-');
              this.usrData.PatientDOB = db[2] + '-' +  db[1] + '-'+db[0];
            }
           

            this.selectedObj = this.deepCopy(data[0]);
            this.hoveredDivId = this.usrData.PatientId;
            this.GetPatientAppointment();
          } else {
            if(!isNaN(id)) {
              this.getUserDetail(id);

            }
           
          }
      }

      },
      error=>{
          this.loading = false;
          this.message = error.data;
      });
  }
  delete(patient: Patient) : void {
    this.loading = true;
    this._usrService.deletePatient( patient).subscribe(data=>{
      this.listLoading = false;
      this.message = "User " + ActionMessage.DELETESUCCESS.toString();
      this.usrData = null;  
      this.getUsers(null);
    },
    error=>{
        this.loading = false;
        this.message = error.data;
    });
  }
  editPatient(data) {
      this.isEditProfile = true;
      if(this.usrData.PatientDOB !== null && this.usrData.PatientDOB !== "") {
        let db = this.usrData.PatientDOB.split('-');
        this.dob =  { date: { year: parseInt(db[2]), month: parseInt(db[1]), day: parseInt(db[0]) } };    
      }
      
  }
  deletePatient() : void {
    this.selectedObject = this.usrData;
    this._sharedService.emitDialog(true,"Delete",ActionMessage.DELETE.toString(),true,DialogAction.DELETE.toString(),'PATIENTPROFILE',this.usrData );   
  }
  showMedicalHistory() : void {
     var historyData = this.medicalHistoryData ;
     var patientData = this.usrData;
     this._sharedService.overlay( {'module' :'PATIENT','type' : 'History','isShow' : true,'data' : patientData, 'secondData' : historyData});
  }
  saveEdit(res) {
    this.isEditProfile = res;
    this.getUsers( this.usrData.PatientId); 
  }
  cancelEdit(res) {
    this.isEditProfile = res;
    this.selectedObj = this.deepCopy(this.usrData);
  }
  GetPatientAppointment() : void {
     
    this.appointmentList = [];
    if(this.appId !=0) {
      this.setActiveTab('CLINICAL');
      setTimeout(() => {
        $('#clinic').click();
      }, 2000);
     
    }
    this._usrService.getPatientAppointment(this.selectedObj.PatientId).subscribe(data=>{
       
        this.appointmentList = data;
         
        var appData = this.appointmentList.filter(function(app){
          return (app.AppointmentIsCancelled === false);
        })
        this.appointmentList = appData;
       
    },
    error=>{
      
    });
  }
  searchPatient() : void {
    if(this.search.text.length<2) {
      return;
    }
    this.Patients = [];
    /*var txtSearch = this.search.text;
    var filterData = null;
    var fText = this.filterText;
    if(fText  !== 'All') {
      filterData  = this.PatientsList.filter(function(user){
        return (user.PatientFirstName.toUpperCase().indexOf(fText.toUpperCase())===0);
      })
      
    } else {
      filterData = this.PatientsList;
    }
    if( txtSearch !== '') {
      var data = filterData.filter(function(user){
        return ((user.PatientFirstName.toUpperCase()+ ' ' +user.PatientLastName.toUpperCase()).replace(/\s/g,'').indexOf( txtSearch.toUpperCase().replace(/\s/g,'') )>-1 || user.PatientLastName.toUpperCase().indexOf( txtSearch.toUpperCase() )>-1|| user.PatientEmailAddress.toUpperCase().indexOf( txtSearch.toUpperCase() )>-1 || user.PatientPrimaryMobNo.toString().toUpperCase().indexOf( txtSearch.toUpperCase() )>-1 || user.Patient_PIN.toUpperCase().indexOf( txtSearch.toUpperCase() )>-1);
      })
      if(data.length>0){
        this.Patients = data;     
      } 
    } else {
      this.Patients = filterData;
    }*/
    this.getUsers(null);
  }
  filterByAlphabet(txt : string) {
    this.search = new Search('');
    this.filterText = txt;
    this.Patients = [];
    /*if(txt !== 'All') {
      var data = this.PatientsList.filter(function(user){
        return (user.PatientFirstName.toUpperCase().indexOf(txt.toUpperCase())===0);
      })
      if(data.length>0){
        this.Patients = data;     
      } 
    } else {
      this.Patients = this.PatientsList;
    }*/
    this.getUsers(null);
   
  }
  getMedicalHistory() : void {
    this.listLoading = true;
     this._mhService.getMedicalHistory().subscribe(
       data=>{
           this.medicalHistoryData  = data;
       },
       error=>{}
     );
  }
  setUser(usr : Patient) {
    this.usrData =usr;
    this.selectedObj = this.deepCopy(usr);
    this.isAddAppointment = false;
    this.GetPatientAppointment();
    
  }

  initProcesss() {
    this.usrData = null;
    var id : number;
    this.id = 0;

    this.sub = this.route.params.subscribe(params => {     
      id = +params['id'];      
      this.id = id; 
      this.appId = +params['appid']; 
   });
   //if(sessionStorage.getItem("data") == undefined) {
    this.getUsers(id);
    this.getMedicalHistory();
  }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem("User"));
    if(this.user=== undefined || this.user=== null) {
        this._userService.getUserProfile().subscribe(data=>{
            if(data !== null && data.length>0) {
            
              this.user = data[0];
              this.initProcesss();
          } else {
            sessionStorage.clear();
            window.location.href="/#/login";
          }
        })
    } else {
      this.initProcesss();
    }
  /*} else {
    this.Patients  = JSON.parse(sessionStorage.getItem("data")).slice(0,100);
    this.PatientsList = JSON.parse(sessionStorage.getItem("data"));
    if(id != undefined && id != null){
        var data = this.PatientsList.filter(function(user){
          return (user.PatientId === id);
        })
        if(data.length>0){
          this.usrData = this.deepCopy(data[0]);
          this.selectedObj = this.deepCopy(data);
          this.hoveredDivId = this.usrData.PatientId;
        } 
    }
  }*/
     
    
  }
   
  ngAfterViewChecked() {
    this._sharedService.emitChange(false);
  }
  ngOnDestroy() {
    this._sharedService.emitChange(true);
  }
  bookAppointment(patient : Patient) {
    //this._sharedService.overlay( {'module' :'PATIENT','type' : 'Appointment','isShow' : true,'data' : null, 'secondData' : this.usrData});
  }
  print() {
     window.open("#/print/"+this.selectedObj.PatientId +"/"+this.appdata);
  }
}



// WEBPACK FOOTER //
// ./src/app/section/patient/view-patient-profile/view-patient-profile.component.ts